import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import moment from "moment";
import axios from "axios";

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      courseList: [],
      oriCourseList: [],
      teacherList: [],
      teacherNames: {},
      studentList: [],
      oriStudentList: [],
      studentNames: {},
      classList: [],
      oriClassList: [],
      classNames: {},
      classType: {},
      // 搜索
      searchStr: "",
      // 待处理考勤日期
      pendingCheckInDate: [],
      // 全选课程
      selectAllCourse: false,
      // 选择日期
      selectedDate: "",
      // 一键签到
      selectedCourseIndexs: [],
      // 查看签到详情
      selectedCourseIndex: 0,
      showCourseCheckInDetail: false,
      // 全选学生
      selectAll: [],
      selectedStudentIds: [],
      absentDeductHour: [],
      leaveDeductHour: [],
      formerValue: 0,
      tipResolver: null,
      showTip: false,
      tipMessage: "",
      tipNeedInput: false,
      tipInputText: ""
    };
  },
  async mounted() {
    const mountT0 = performance.now();
    let stepT0 = mountT0;
    const logStep = label => {
      const t = performance.now();
      console.log(`[checkIn mounted] ${label}: ${(t - stepT0).toFixed(1)}ms`);
      stepT0 = t;
    };

    // 初始当天日期
    this.selectedDate = moment().format("YYYY-MM-DD");
    logStep("初始化 selectedDate");
    await Promise.all([(async () => {
      const t0 = performance.now();
      await this.getTeacherList();
      console.log(`[checkIn mounted] getTeacherList 用时: ${(performance.now() - t0).toFixed(1)}ms`);
    })(), (async () => {
      const t0 = performance.now();
      await this.getStudentList();
      console.log(`[checkIn mounted] getStudentList 用时: ${(performance.now() - t0).toFixed(1)}ms`);
    })(), (async () => {
      const t0 = performance.now();
      await this.getClassList();
      console.log(`[checkIn mounted] getClassList 用时: ${(performance.now() - t0).toFixed(1)}ms`);
    })()]);
    logStep("并行：getTeacherList / getStudentList / getClassList");

    // 获取某天有哪些课程，每个课程有多少学生
    await this.getCourse();
    logStep("getCourse");

    // 获取哪些日期有课程未考勤
    await this.getPendingCheckIn();
    logStep("getPendingCheckIn");

    // 更新菜单栏，当日考勤的红色圈数字
    this.$emit("updateVariable");
    logStep("$emit(updateVariable)");
    console.log(`[checkIn mounted] 总用时: ${(performance.now() - mountT0).toFixed(1)}ms`);
  },
  methods: {
    //获取老师列表(筛选出启用的)
    async getTeacherList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution,
          flag: "onlyActive" //(筛选出启用的)
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/getTeacherList", params);
        if (resp1.data.code == "0000") {
          this.teacherList = resp1.data.data;
          for (let i in this.teacherList) {
            this.teacherList[i].courses = this.teacherList[i].coursesStr.split("/");
          }

          // console.log("获取老师列表 this.teacherList:", this.teacherList);

          this.teacherNames = {};
          for (let i = 0; i < this.teacherList.length; i++) {
            this.teacherNames[this.teacherList[i].id] = this.teacherList[i].name;
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 获取学生列表
    async getStudentList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getStudentList", params);
        if (resp1.data.code == "0000") {
          this.studentList = resp1.data.data;

          // console.log("获取学生列表:", this.studentList);

          this.oriStudentList = JSON.parse(JSON.stringify(this.studentList));
          this.studentNames = {};
          for (let i = 0; i < this.studentList.length; i++) {
            this.studentNames[this.studentList[i].id] = this.studentList[i].name;
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取某天课程，每个课程有多少学生
    async getCourse() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution,
          date: this.selectedDate
        };
        let resp1 = await axios.post("https://backend.wonology.com/checkIn/getCourse", params);
        if (resp1.data.code == "0000") {
          this.courseList = resp1.data.data;

          // json化
          for (let i = 0; i < this.courseList.length; i++) {
            if (!this.courseList[i].studentCheckInStatus) {
              this.courseList[i].studentCheckInStatus = {};
            } else {
              this.courseList[i].studentCheckInStatus = JSON.parse(this.courseList[i].studentCheckInStatus);
            }
          }

          // 计算已处理考勤人数
          for (let i = 0; i < this.courseList.length; i++) {
            let checkedStudentNum = 0;
            for (let studentId in this.courseList[i].studentCheckInStatus) {
              studentId = parseInt(studentId);

              // 有考勤状态
              if (this.courseList[i].studentCheckInStatus[studentId].status != 0) {
                // 有考勤状态的，还得是报名了这个课程的学生
                if (this.courseList[i].studentIds && this.courseList[i].studentIds.includes(studentId)) {
                  checkedStudentNum++;
                }
              }
            }
            this.courseList[i].checkedStudentNum = checkedStudentNum;
          }

          // console.log("this.courseList:", this.courseList);

          this.oriCourseList = JSON.parse(JSON.stringify(this.courseList));
          this.absentDeductHour = [];
          this.leaveDeductHour = [];
          for (let i = 0; i < this.courseList.length; i++) {
            let absentDeductHour = parseFloat((this.calculateTimeDuration(this.courseList[i].period).totalMinutes / 60).toFixed(2));
            this.absentDeductHour.push(absentDeductHour);
            this.leaveDeductHour.push(0);
            this.selectAll.push(false);
            this.selectedStudentIds.push([]);
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 获取班级列表
    async getClassList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getClassList", params);
        if (resp1.data.code == "0000") {
          this.classList = resp1.data.data;

          // 部分字段json.parse()
          for (let i in this.classList) {
            this.classList[i].teacherIds = JSON.parse(this.classList[i].teacherIds);
            // 将 teacherId 倒序排列
            this.classList[i].teacherIds.sort((a, b) => b - a);
            this.classList[i].courses = JSON.parse(this.classList[i].courses);
            this.classList[i].periods = JSON.parse(this.classList[i].periods);
          }
          this.oriClassList = JSON.parse(JSON.stringify(this.classList));

          // console.log("获取班级列表 this.classList:", this.classList);

          // classId转换为className
          for (let i = 0; i < this.classList.length; i++) {
            this.classNames[this.classList[i].id] = this.classList[i].name;
            this.classType[this.classList[i].id] = this.classList[i].courseType;
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 获取待处理考勤的日期
    async getPendingCheckIn() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/checkIn/getPendingCheckIn", params);
        if (resp1.data.code == "0000") {
          this.pendingCheckInDate = resp1.data.data;
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 搜索
    search() {
      // console.log("this.searchStr:", this.searchStr);
      let courseList = [];
      for (let i in this.oriCourseList) {
        if (this.classNames[this.oriCourseList[i].classId].toLowerCase().includes(this.searchStr.toLowerCase())) {
          courseList.push(this.oriCourseList[i]);
          continue;
        }
        if (this.teacherNames[this.oriCourseList[i].teacherId].toLowerCase().includes(this.searchStr.toLowerCase())) {
          courseList.push(this.oriCourseList[i]);
          continue;
        }
      }
      this.courseList = courseList;
    },
    // 点击 下拉框，展开下拉菜单
    async clickDateSelect() {
      // await this.getPendingCheckIn();

      // 通过 this.$refs 获取 el-select 实例
      const select = this.$refs.dateSelectRef;
      if (select) {
        // 先聚焦（可选，但推荐）
        select.focus();
        // 调用 toggleMenu 展开/收起下拉菜单
        select.toggleMenu();
      }
    },
    // handleDateChange() {

    // },

    // 全选课程
    selectAllCourseChange() {
      this.selectedCourseIndexs = [];
      if (this.selectAllCourse) {
        for (let i = 0; i < this.courseList.length; i++) {
          this.selectedCourseIndexs.push(i);
        }
      } else {
        this.selectedCourseIndexs = [];
      }
    },
    // 点击全选课程文字，也是点击全选课程
    clickAllCourseWord() {
      this.selectAllCourse = !this.selectAllCourse;
      this.selectAllCourseChange();
    },
    // 选择日期
    async handleDateChange() {
      this.selectAllCourse = false;
      this.selectedCourseIndexs = [];
      await this.getCourse();

      // this.search();
      this.searchStr = "";
    },
    // 一键签到，选中的课程都打开详情
    async allCheckIn() {
      if (this.selectedCourseIndexs.length == 0) {
        alert("未选择课程");
        return;
      }
      this.showCourseCheckInDetail = true;
    },
    // 选择课程
    clickCourse(courseIndex) {
      if (this.selectedCourseIndexs.includes(courseIndex)) {
        this.selectedCourseIndexs = this.selectedCourseIndexs.filter(item => item != courseIndex);
      } else {
        this.selectedCourseIndexs.push(courseIndex);
      }
    },
    // 课程签到详情
    seeCourseCheckInDetail(courseIndex) {
      // 阻止事件冒泡，点击事件这里处理，不传给父组件的click
      event.stopPropagation();

      // this.selectedCourseIndex = courseIndex;
      this.selectedCourseIndexs = [courseIndex];

      // this.absentDeductHour = parseFloat(
      //   (
      //     this.calculateTimeDuration(this.courseList[courseIndex].period)
      //       .totalMinutes / 60
      //   ).toFixed(2)
      // );

      // 重置变量
      this.selectAll[courseIndex] = false;
      this.selectedStudentIds[courseIndex] = [];
      this.showCourseCheckInDetail = true;
    },
    async cancelCourseCheckInDetail() {
      // await this.getPendingCheckIn();

      // 更新菜单栏，当日考勤的数字
      // this.$emit("updateVariable");

      this.showCourseCheckInDetail = false;
    },
    // 限制只能输入浮点数，最多一位小数
    handleFloatInput(dataType, courseIndex, value) {
      // console.log("handleFloatInput value type:", typeof value);

      // 允许空值
      if (value === "") {
        // if (dataType == "absentDeductHour") {
        //   this.absentDeductHour = 0;
        // }
        // if (dataType == "leaveDeductHour") {
        //   this.leaveDeductHour = 0;
        // }

        return;
      }

      // 移除所有非数字和小数点的字符 (防止本来是1，在1前面输入a, a1，反而会删了1，变成a)
      value = value.replace(/[^\d.]/g, "");

      // 正则表达式匹配数字和小数点后最多一位小数
      const regex = /^\d*\.?\d{0,1}$/;

      // 如果符合格式
      if (regex.test(value)) {
        // 去除前导零，但保留小数点前的零（如 0.5 的情况）
        if (value.startsWith("0") && value.length > 1 && value.charAt(1) !== ".") {
          value = value.replace(/^0+/, "") || "0";
        }

        // // 处理小数点后没有数字的情况（如 "1."）
        // if (value.endsWith(".")) {
        //   // 如果只是单独的小数点，则变为 "0"
        //   if (value === ".") {
        //     value = "0";
        //   } else {
        //     // 去掉末尾的小数点，保留前面的整数部分
        //     value = value.slice(0, -1);
        //   }
        // }
      }
      // 不符合格式
      else {
        // 移除最后一个无效字符
        // value = value.slice(0, -1);

        // 恢复为前一个值
        value = this.formerValue;
      }

      // 保存当前值
      this.formerValue = value;

      // 更新
      if (dataType == "absentDeductHour") {
        this.absentDeductHour[courseIndex] = value;

        // console.log("this.absentDeductHour:", this.absentDeductHour);
        // console.log("typeof this.absentDeductHour:", typeof this.absentDeductHour);
      }
      if (dataType == "leaveDeductHour") {
        this.leaveDeductHour[courseIndex] = value;

        // console.log("this.leaveDeductHour:", this.leaveDeductHour);
      }
    },
    // 全选学生
    selectAllChange(courseIndex) {
      // 取消全选
      if (!this.selectAll[courseIndex]) {
        this.selectedStudentIds[courseIndex] = [];
      }
      // 全选
      else {
        this.selectedStudentIds[courseIndex] = [];
        for (let i = 0; i < this.courseList[courseIndex].studentIds.length; i++) {
          this.selectedStudentIds[courseIndex].push(this.courseList[courseIndex].studentIds[i]);
        }
      }
    },
    // 点击全选文字，也是全选
    clickAllWord(courseIndex) {
      this.selectAll[courseIndex] = !this.selectAll[courseIndex];
      this.selectAllChange(courseIndex);
    },
    selectedStudentIdsChange(courseIndex) {
      // console.log("courseIndex:", courseIndex);
      // console.log(
      //   "this.selectedStudentIds[courseIndex]:",
      //   this.selectedStudentIds[courseIndex]
      // );
    },
    // 点击学生名，也是选中学生
    selectStudent(courseIndex, studentId) {
      if (this.selectedStudentIds[courseIndex].includes(studentId)) {
        this.selectedStudentIds[courseIndex] = this.selectedStudentIds[courseIndex].filter(item => item != studentId);
      } else {
        this.selectedStudentIds[courseIndex].push(studentId);
      }

      // console.log("courseIndex:", courseIndex);
      // console.log(
      //   "this.selectedStudentIds[courseIndex]:",
      //   this.selectedStudentIds[courseIndex]
      // );
    },
    // 设置状态为 签到
    async checkIn() {
      for (let i = 0; i < this.selectedCourseIndexs.length; i++) {
        let courseIndex = this.selectedCourseIndexs[i];
        await this.updateCheckInStatus(courseIndex, 1);
      }

      // if (this.selectedStudentIds.length == 0) {
      //   alert("未选择学生");

      //   return;
      // }

      // await this.updateCheckInStatus(courseIndex, 1);
    },
    // 设置状态为 缺勤
    async absent() {
      for (let i = 0; i < this.selectedCourseIndexs.length; i++) {
        let courseIndex = this.selectedCourseIndexs[i];

        // 判断缺勤扣除课时不能为空
        if (this.absentDeductHour[courseIndex] == undefined) {
          alert(`请填写'${this.classNames[this.courseList[courseIndex].classId]}'的缺勤扣除课时`);
          return;
        }

        // 判断缺勤扣除课时不能大于课程总课时
        let minutes = this.calculateTimeDuration(this.courseList[courseIndex].period).totalMinutes;
        if (this.absentDeductHour[courseIndex] * 60 > minutes) {
          alert(`'${this.classNames[this.courseList[courseIndex].classId]}'的缺勤扣除课时不能大于课程总课时`);
          return;
        }
        await this.updateCheckInStatus(courseIndex, 2);
      }

      // if (this.selectedStudentIds.length == 0) {
      //   alert("未选择学生");

      //   return;
      // }

      // await this.updateCheckInStatus(2);
    },
    // 设置状态为 请假
    async leave() {
      for (let i = 0; i < this.selectedCourseIndexs.length; i++) {
        let courseIndex = this.selectedCourseIndexs[i];
        console.log("this.leaveDeductHour:", this.leaveDeductHour);

        // 判断请假扣除课时不能为空
        if (this.leaveDeductHour[courseIndex] == undefined) {
          alert(`请填写'${this.classNames[this.courseList[courseIndex].classId]}'的请假扣除课时`);
          return;
        }

        // 判断请假扣除课时不能大于课程总课时
        let minutes = this.calculateTimeDuration(this.courseList[courseIndex].period).totalMinutes;
        if (this.leaveDeductHour[courseIndex] * 60 > minutes) {
          alert(`'${this.classNames[this.courseList[courseIndex].classId]}'的请假扣除课时不能大于课程总课时`);
          return;
        }

        // 如果是请假，需要备注原因
        this.showTip = true;
        this.tipMessage = `请假原因`;
        this.tipNeedInput = true;
        this.tipInputText = "";

        // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
        // 后面通过 this.tipResolver(value) 返回值
        const tipConfirmed = await new Promise(resolve => {
          this.tipResolver = resolve;
        });
        if (tipConfirmed === "confirm") {
          // 用户选择确认，继续执行

          // 必须写请假原因
          if (!this.tipInputText) {
            alert("请填写请假原因");
            return;
          }
          this.showTip = false;
          // 重置变量
          this.tipMessage = "";
          this.tipNeedInput = false;
        } else {
          // 用户选择取消，返回

          return;
        }
        await this.updateCheckInStatus(courseIndex, 3);
      }
    },
    async updateCheckInStatus(courseIndex, status) {
      let isPaidStudentIndexs = [];
      // 如果已经有学生设置了考勤状态
      for (let i = 0; i < this.selectedStudentIds[courseIndex].length; i++) {
        let studentId = this.selectedStudentIds[courseIndex][i];

        // 如果已经有学生设置了考勤状态
        if (this.courseList[courseIndex].studentCheckInStatus[studentId] && this.courseList[courseIndex].studentCheckInStatus[studentId].status != 0) {
          // 如果考勤状态导致的金额异动，已经缴费了，就不能修改了
          if (this.courseList[courseIndex].studentCheckInStatus[studentId].isPaid) {
            alert(`${this.studentNames[studentId]}的考勤状态导致的金额异动已经缴费，不能修改考勤状态`);
            isPaidStudentIndexs.push(i);
            continue;
          }

          // 弹出确认弹窗
          this.showTip = true;
          this.tipMessage = `${this.studentNames[studentId]}已有考勤状态，是否确认修改`;

          // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
          // 后面通过 this.tipResolver(value) 返回值
          const tipConfirmed = await new Promise(resolve => {
            this.tipResolver = resolve;
          });
          if (tipConfirmed === "confirm") {
            // 用户选择确认，继续执行

            this.showTip = false;
            // 重置变量
            this.tipMessage = "";
            this.tipNeedInput = false;
            break;
          } else {
            // 用户选择取消，返回

            return;
          }
        }
      }

      // 更新学生考勤状态
      // 去掉已经缴费，不能更新考勤状态的学生
      for (let i = 0; i < isPaidStudentIndexs.length; i++) {
        this.selectedStudentIds[courseIndex].splice(isPaidStudentIndexs[i], 1);
      }
      if (this.selectedStudentIds[courseIndex].length == 0) {
        return;
      }
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        // console.log("courseIndex:", courseIndex);
        // console.log("this.selectedStudentIds[courseIndex]:", this.selectedStudentIds[courseIndex]);

        let params = {
          studentIds: this.selectedStudentIds[courseIndex],
          status: status,
          remark: this.tipInputText,
          courseArrangeId: this.courseList[courseIndex].id,
          username: this.userInfo.name,
          absentDeductHour: this.absentDeductHour[courseIndex],
          leaveDeductHour: this.leaveDeductHour[courseIndex]
        };
        let resp1 = await axios.post("https://backend.wonology.com/checkIn/setStudentCheckInStatus", params);
        if (resp1.data.code == "0000") {
          this.courseList[courseIndex].studentCheckInStatus = resp1.data.data;

          // 计算已处理考勤人数
          let checkedStudentNum = 0;
          for (let studentId in this.courseList[courseIndex].studentCheckInStatus) {
            studentId = parseInt(studentId);
            if (this.courseList[courseIndex].studentCheckInStatus[studentId].status != 0) {
              // 有考勤状态的，还得是报名了这个课程的学生
              if (this.courseList[courseIndex].studentIds && this.courseList[courseIndex].studentIds.includes(studentId)) {
                checkedStudentNum++;
              }
            }
          }
          this.courseList[courseIndex].checkedStudentNum = checkedStudentNum;
          this.selectedStudentIds[courseIndex] = [];
          this.selectAll[courseIndex] = false;
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 计算hh:mm-hh:mm 时间段长度的方法
    calculateTimeDuration(timeRange) {
      // timeRange 格式: "09:00-10:30"
      const [startTime, endTime] = timeRange.split("-");

      // 将时间字符串转换为分钟数
      const parseTimeToMinutes = timeStr => {
        const [hours, minutes] = timeStr.split(":").map(Number);
        return hours * 60 + minutes;
      };
      const startMinutes = parseTimeToMinutes(startTime);
      const endMinutes = parseTimeToMinutes(endTime);

      // 计算时间差（分钟）
      const durationMinutes = endMinutes - startMinutes;

      // 转换为小时和分钟
      const hours = Math.floor(durationMinutes / 60);
      const minutes = durationMinutes % 60;
      return {
        totalMinutes: durationMinutes,
        hours: hours,
        minutes: minutes,
        formatted: `${hours}小时${minutes}分钟`
      };
    },
    // 提示弹窗 取消
    closeTip() {
      this.showTip = false;
      // 重置变量
      this.tipMessage = "";
      this.tipNeedInput = false;
      if (this.tipResolver) {
        // 传输结果
        this.tipResolver("cancel");
        this.tipResolver = null;
      }
    },
    confirmTip() {
      // this.showTip = false;
      // // 重置变量
      // this.tipMessage = "";
      // this.tipNeedInput = false;

      if (this.tipResolver) {
        // 传输结果
        this.tipResolver("confirm");
        this.tipResolver = null;
      }
    }
  }
};